"use client"

import { useState } from 'react'
import Autocomplete from 'react-google-autocomplete'

export default function BookingForm({ dict }) {
  const [pickup, setPickup] = useState('')
  const [destinations, setDestinations] = useState([''])
  const [date, setDate] = useState('')
  const [passengers, setPassengers] = useState('1')
  const [vehicleType, setVehicleType] = useState('sedan')

  const handleAddDestination = () => {
    setDestinations([...destinations, ''])
  }

  const handleDestinationChange = (index, value) => {
    const newDestinations = [...destinations]
    newDestinations[index] = value
    setDestinations(newDestinations)
  }

  const handleRemoveDestination = (index) => {
    if (destinations.length > 1) {
      const newDestinations = destinations.filter((_, i) => i !== index)
      setDestinations(newDestinations)
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    
    // Default placeholder number. User can change this in the code.
    const WHATSAPP_NUMBER = "84972066228" // Real WhatsApp number

    const text = `Hello! I would like to book a car.
    
Details:
- Pickup: ${pickup}
- Destinations: 
${destinations.map((dest, i) => `  ${i + 1}. ${dest}`).join('\n')}
- Date: ${date}
- Passengers: ${passengers}
- Vehicle Type: ${vehicleType}`

    const encodedText = encodeURIComponent(text)
    const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodedText}`
    
    window.open(whatsappUrl, '_blank')
  }

  return (
    <form className="booking-form" onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
      <div style={{ display: 'flex', gap: '10px' }}>
        <Autocomplete
          apiKey={process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY}
          onPlaceSelected={(place) => setPickup(place.formatted_address || place.name)}
          options={{
            types: ['establishment', 'geocode'],
            componentRestrictions: { country: 'vn' },
          }}
          defaultValue={pickup}
          onChange={(e) => setPickup(e.target.value)}
          placeholder={dict.formPickup || "Pickup Location"}
          required
          style={{ flex: 1, padding: '12px', borderRadius: '4px', border: '1px solid #ccc' }}
        />
      </div>

      {destinations.map((dest, index) => (
        <div key={index} style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
          <Autocomplete
            apiKey={process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY}
            onPlaceSelected={(place) => handleDestinationChange(index, place.formatted_address || place.name)}
            options={{
              types: ['establishment', 'geocode'],
              componentRestrictions: { country: 'vn' },
            }}
            defaultValue={dest}
            onChange={(e) => handleDestinationChange(index, e.target.value)}
            placeholder={`Destination ${index + 1}`} 
            required 
            style={{ flex: 1, padding: '12px', borderRadius: '4px', border: '1px solid #ccc' }}
          />
          {destinations.length > 1 && (
            <button 
              type="button" 
              onClick={() => handleRemoveDestination(index)}
              style={{ padding: '12px', background: '#ff4d4f', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
            >
              ✕
            </button>
          )}
        </div>
      ))}
      
      <div style={{ textAlign: 'left' }}>
        <button 
          type="button" 
          onClick={handleAddDestination}
          style={{ background: 'none', color: '#0F2027', border: '1px solid #0F2027', padding: '6px 12px', borderRadius: '4px', cursor: 'pointer', fontSize: '0.9rem' }}
        >
          + Add another stop
        </button>
      </div>
      
      <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
        <input 
          type="date"
          className={date ? "" : "empty-date"}
          data-placeholder="Select Date (dd/mm/yyyy)"
          value={date}
          onChange={(e) => setDate(e.target.value)}
          required 
          style={{ flex: 1, minWidth: '150px', padding: '12px', borderRadius: '4px', border: '1px solid #ccc' }}
        />
        <select 
          value={passengers} 
          onChange={(e) => setPassengers(e.target.value)}
          style={{ flex: 1, minWidth: '120px', padding: '12px', borderRadius: '4px', border: '1px solid #ccc' }}
        >
          <option value="1">1 Passenger</option>
          <option value="2">2 Passengers</option>
          <option value="3">3 Passengers</option>
          <option value="4">4 Passengers</option>
          <option value="5+">5+ Passengers</option>
        </select>
        <select 
          value={vehicleType} 
          onChange={(e) => setVehicleType(e.target.value)}
          style={{ flex: 1, minWidth: '140px', padding: '12px', borderRadius: '4px', border: '1px solid #ccc' }}
        >
          <option value="sedan">4-Seat Sedan</option>
          <option value="suv">7-Seat SUV</option>
          <option value="van">16-Seat Van</option>
        </select>
      </div>

      <button type="submit" className="btn-primary" style={{ padding: '15px', fontSize: '1.1rem', fontWeight: 'bold', marginTop: '10px' }}>
        {dict.formSubmit || "Book Now via WhatsApp"}
      </button>
    </form>
  )
}
